module.exports = __webpack_public_path__ + "img/ghost-mode-setting.8954b185.webp";